import useBrandTranslation from "../hooks/useBrandTranslation";

export default function MercadoPagoFailure() {
  const { t } = useBrandTranslation();
  return (
    <main className="flex min-h-screen flex-col items-center justify-center p-4 md:p-24">
      <h1 className="text-2xl font-bold text-red-600 mb-4">
        {t("app.payments.failureTitle", "¡Pago fallido!")}
      </h1>
      <p className="text-lg text-gray-700 mb-8">
        {t(
          "app.payments.failureBody",
          "Tu pago no se ha completado. Por favor, intenta nuevamente o contacta al soporte si el problema persiste."
        )}
      </p>
      <a
        href="/"
        className="px-6 py-3 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
      >
        {t("common.backToHome", "Volver al inicio")}
      </a>
      <p className="mt-4 text-sm text-gray-500">
        {t(
          "app.payments.supportHint",
          "Si necesitas ayuda, por favor contacta a nuestro equipo de soporte."
        )}
      </p>
    </main>
  );
}
